import { useCallback } from "react";
import { StepperProps, StepStatus } from "./constants";
import { defaultGetStatus } from "./utils";

type UseStepperResult = {
  getStatus: (index: number) => StepStatus;
  handleStepClick: (index: number, status: StepStatus) => void;
  prevIndex: number;
  prevStatus: StepStatus | null;
  progressPercent: number;
};

const useStepper = ({
  steps,
  currentStep,
  onStepChange,
  getStepStatus,
  disableNav,
}: Pick<StepperProps, "steps" | "currentStep" | "onStepChange" | "getStepStatus" | "disableNav">): UseStepperResult => {
  const getStatus = useCallback(
    (index: number): StepStatus =>
      getStepStatus ? getStepStatus(index) : defaultGetStatus(index, currentStep),
    [getStepStatus, currentStep]
  );

  const handleStepClick = useCallback(
    (index: number, status: StepStatus) => {
      if (disableNav || status === "disabled") return;
      onStepChange?.(index);
    },
    [disableNav, onStepChange]
  );

  const prevIndex = currentStep - 1;
  const prevStatus = steps[prevIndex] ? getStatus(prevIndex) : null;
  const progressPercent = ((currentStep + 1) * 100) / steps.length;

  return { getStatus, handleStepClick, prevIndex, prevStatus, progressPercent };
};

export default useStepper;
